import { createSlice } from "@reduxjs/toolkit";
import { tableKey } from "../../../utils/constants";

const initialState = {
  adminUnitsTotalPages: 1,
  adminTenantsTotalPages: 1,
  adminApprovalsTotalPages: 1,
  adminNotesTotalPages: 1,
  adminMessagesTotalPages: 1,
  adminInvoiceTotalPages: 1,
  adminCleaningTotalPages: 1,
  adminCleanerTotalPages: 1,
  adminCarParkingTotalPages: 1,
  adminTenantPaymentHistoryTotalPages: 1,
  tenantPaymentHistoryTotalPages: 1,
};

const totalPagesSlice = createSlice({
  name: "totalPages",
  initialState,
  reducers: {
    updateTotalPages: (state, action) => {
      const { currentTableKey, currentTotalPages } = action.payload;

      switch (currentTableKey) {
        case tableKey.ADMIN__UNITS__ALL_UNITS:
          state.adminUnitsTotalPages = currentTotalPages;
          break;
        case tableKey.ADMIN__TENANTS__TENANTS:
          state.adminTenantsTotalPages = currentTotalPages;
          break;
        case tableKey.ADMIN__APPROVALS__APPROVALS:
          state.adminApprovalsTotalPages = currentTotalPages;
          break;
        case tableKey.ADMIN__NOTES__NOTES:
          state.adminNotesTotalPages = currentTotalPages;
          break;
        case tableKey.ADMIN__MESSAGES__MESSAGES:
          state.adminMessagesTotalPages = currentTotalPages;
          break;
        case tableKey.ADMIN__INVOICES__INVOICES:
          state.adminInvoiceTotalPages = currentTotalPages;
          break;
        case tableKey.ADMIN__CLEANING__CLEANING:
          state.adminCleaningTotalPages = currentTotalPages;
          break;
        case tableKey.ADMIN__CLEANING__CLEANER:
          state.adminCleaningTotalPages = currentTotalPages;
          break;
        case tableKey.ADMIN__CAR_PARKING__CAR_PARKING:
          state.adminCarParkingTotalPages = currentTotalPages;
          break;
        case tableKey.TENANT__PAYMENT_HISTORY:
          state.tenantPaymentHistoryTotalPages = currentTotalPages;
          break;
        default:
          // Handle the default case if needed
          break;
      }
    },
  },
});

export const { updateTotalPages } = totalPagesSlice.actions;
export default totalPagesSlice.reducer;
